import React from "react";
import Navbar from "../navbar";
import Footer from "../footer";
import "./style.scss";
// import IpLocation from "ip-location";
// import axios from "axios";
import SEO from "../seo";

import { Link } from "gatsby";

import blogData from "./data";

export default function BlogInner(props) {
  const { location, data } = props;

  const { blogImg, blogTitle, content, date, seoDescription, seoImg } = data;

  var prev = null;
  var next = null;

  let i = 0;

  blogData.forEach((item, it) => {
    if (location.pathname.includes(item.link)) {
      i = it;
    }
  });

  if (i === 0) {
    prev = null;
  } else {
    prev = (
      <Link className="blog__bottombuttons__prev" to={blogData[i - 1].link}>
        <i class="fas fa-arrow-left"></i> Prev
      </Link>
    );
  }

  if (i === blogData.length - 1) {
    next = null;
  } else {
    next = (
      <Link className="blog__bottombuttons__next" to={blogData[i + 1].link}>
        Next <i class="fas fa-arrow-right"></i>
      </Link>
    );
  }

  return (
    <div className="blog">
      <SEO
        title={blogTitle + " | Eclipse"}
        description={seoDescription}
        img={seoImg}
      />
      <Navbar />
      <div className="blog__content">
        <h1 className="blog__title">{blogTitle}</h1>
        <div className="blog__header">
          <div className="blog__header__date">{date}</div>
          <div className="blog__header__socialshare">
            Share&nbsp; &nbsp;
            <span className="hicon">
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-facebook-f"></i>
              </a>
            </span>
            <span className="hicon">
              <a
                href={`https://twitter.com/intent/tweet?url=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-twitter"></i>
              </a>
            </span>
            <span className="hicon">
              <a
                href={`https://www.linkedin.com/sharing/share-offsite/?url=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-linkedin-in"></i>
              </a>
            </span>
          </div>
        </div>
        <img
          className="blog__headerimg"
          src={blogImg}
          alt="Blog Header Image"
        ></img>

        <div
          className="blog__container"
          dangerouslySetInnerHTML={{
            __html: content.replace(/[\r\n]+/gm, ""),
          }}
        ></div>

        <center>
          <div className="blog__header__socialshare">
            Share &nbsp; &nbsp;
            <span className="hicon">
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-facebook-f"></i>
              </a>
            </span>
            <span className="hicon">
              <a
                href={`https://twitter.com/intent/tweet?url=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-twitter"></i>
              </a>
            </span>
            <span className="hicon">
              <a
                href={`https://www.linkedin.com/sharing/share-offsite/?url=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-linkedin-in"></i>
              </a>
            </span>
          </div>
        </center>

        <div className="blog__bottombuttons">
          {prev} {next}
        </div>
      </div>
      <br />
      <br />
      <br />
      <Footer />
    </div>
  );
}
